import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import axios from "axios";
import "../css/course-blog.css";
import { toast } from "react-toastify";
import validator from "validator";
import "react-toastify/dist/ReactToastify.css";

// const { htmlToText } = require('html-to-text');

class Readmoreblog extends Component {
  constructor(props) {
    super(props);
    const allBlogs = [];
    const url = [];
    const content = [];
    const name = "";
    const email = "";
    const contact = "";
    this.state = {
      content,
      allBlogs,
      url,
      name,
      email,
      contact,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.getreadblogdetails();
  }

  async getreadblogdetails() {
    // console.log(
    //   " in pathname" + window.location.pathname.replace("/blog/", "")
    // );
    var varvalue = window.location.pathname.replace("/blog/", "");
    //  console.log(" in varvalue === " + varvalue);

    let formData = new FormData();
    formData.append("id", varvalue);

    axios
      .post("Login/blogdetails", formData)
      .then((res) => {
        if (res.data.status === "200") {
          this.setState({
            allBlogs: res.data.allBlogs,
            url: res.data.url,
            content: res.data.content,
          });

          return res;
        }
        throw res;
      })
      .catch((error) => {});
  }

  handleChange(event) {
    let name = event.target.name;
    let val = event.target.value;
    this.setState({ [name]: val });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.savedetails();
  }

  async savedetails() {
    if (
      this.state.email === "" ||
      this.state.name === "" ||
      this.state.contact === ""
    ) {
      toast.error("All Fields are mandatory");
      return;
    } else if (!validator.isEmail(this.state.email)) {
      toast.error("Please enter valid email");
      return;
    } else if (
      this.state.contact.length < 6 ||
      this.state.contact.length > 10
    ) {
      toast.error("Please enter valid Phone no , without prefix ");
      return;
    } else if (!this.state.name.match(/^[a-zA-Z]+$/)) {
      toast.error(" Please enter valid Name ");
      return;
    } else {
      var formData = new FormData();
      formData.append("name", this.state.name);
      formData.append("email", this.state.email);
      formData.append("contact", this.state.contact);
      axios
        .post("Login/Saveenquiry", formData)

        .then((res) => {
          if (res.data.status === "200") {
            toast.success("Thank You. Your response has been recorded !! ");
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  }

  render() {
    const mystyle = {
      lineheight: "1.0",
      backgroundColor: "DodgerBlue",
    };

    const contactusmobile = {
      fontsize: "16px !important ",
      padding: "5px",
      justifyContent: "center",
      alignItems: "center",
    };

    return (
      <div>
        <br /> <br />
        <div aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <Link>
                <FontAwesomeIcon icon={faHome} /> &nbsp; HOME
              </Link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Blog
            </li>
          </ol>
        </div>
        <section class="padding-default">
          <div class="row">
            <div class="col-lg-8 col-sm-8 col-md-8 card-left">
              <div class="card ">
                <div class="container">
                  <img
                    src={this.state.url}
                    alt="..."
                    class="card-img-top img-thumbnail"
                  />
                  <br />

                  <div class="row">
                    <div class="box_grid wrapper col-lg-12 blogView">
                      {/* { htmlToText(this.state.content,{ wordwrap: 130})} */}
                      <span
                        dangerouslySetInnerHTML={{ __html: this.state.content }}
                      />
                      <br /> <br /> <br />
                      <div class="bg-purple-gradient">
                        <br />
                        <h3 class="text-center text-white">
                          Upgrade Your Technical Skills{" "}
                        </h3>
                        <p class="text-center text-white">
                          Take your career to new heights with edu plus now
                          online courses.
                        </p>
                        <a href="/" target="_blank">
                          <p class="text-center">
                            <button class="btn_1 rounded">Know More </button>{" "}
                          </p>
                        </a>
                        <br />
                      </div>
                      <div class="row">
                        <div id="fb-root"></div>
                        <div
                          class="fb-comments"
                          id="fbc"
                          data-href=""
                          data-numposts="5"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 card-right">
              <div class="box_detail" id="social-float" style={{ mystyle }}>
                <div class="row contanint-display">
                  <h3>
                    Get Free Career Advice
                    <hr
                      style={{
                        color: "slateblue",
                        backgroundColor: "slateblue",
                        height: "5px",
                        margintop: " 0.0em",
                        marginbottom: "0.5em",
                        marginleft: "auto",
                        marginright: "auto",
                      }}
                    />
                  </h3>
                  <form action="contactMe" onSubmit={this.handleSubmit}>
                    <b>Your Name</b>

                    <input
                      class="form-control"
                      id="name"
                      required=""
                      type="text"
                      name="name"
                      onChange={this.handleChange}
                    />

                    <b>Your email</b>

                    <input
                      class="form-control"
                      id="email"
                      type="text"
                      required=""
                      name="email"
                      onChange={this.handleChange}
                    />

                    <b>Your Telephone Number</b>

                    <input
                      class="form-control"
                      id="contact"
                      type="number"
                      required=""
                      name="contact"
                      onChange={this.handleChange}
                    />
                    <br />
                    <div id="recaptcha"></div>
                    <div id="message_contact"></div>
                    <div id="elementsToOperateOn">
                      <br />

                      <button
                        type="submit"
                        class="btn_1 rounded"
                        id="exd-career"
                      >
                        Call Me
                      </button>
                    </div>
                  </form>
                  <br />
                  <h3>
                    Or give missed call on
                    <br />
                  </h3>
                  <div class="row">
                    <a href="tel://8956167195" style={contactusmobile}>
                      <FontAwesomeIcon icon={faPhoneAlt} />
                      +918956167195{" "}
                    </a>{" "}
                    &nbsp;
                    <a href="tel://8956167196" style={contactusmobile}>
                      <FontAwesomeIcon icon={faPhoneAlt} /> +918956167196{" "}
                    </a>{" "}
                  </div>
                  <div class="row">
                    <a href="tel://8956167197" style={contactusmobile}>
                      <FontAwesomeIcon icon={faPhoneAlt} /> +918956167197{" "}
                    </a>{" "}
                    &nbsp;
                    <a href="tel://8956167198" style={contactusmobile}>
                      <FontAwesomeIcon icon={faPhoneAlt} /> +918956167198{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <br />
      </div>
    );
  }
}

export default Readmoreblog;
